import React, { useState, forwardRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import InputLabel from "@mui/material/InputLabel";
import "react-datepicker/dist/react-datepicker.css";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

export default function UiDateRangePicker(props) {
     const [dateRange, setDateRange] = useState([null, null]);
     const [startDate, endDate] = dateRange;

     const CustomInput = React.forwardRef((props, ref) => {
          return (
               <>
                    <InputLabel>Date Range</InputLabel>
                    <OutlinedInput
                         id="search"
                         type="text"
                         label="Date Range"
                         fullWidth
                         {...props}
                         ref={ref}
                    />
               </>
          );
     });

     return (
          <>
               <div className="sba-date-range-picker">
                    <FormControl
                         sx={{ mb: 2 }}
                         variant="outlined"
                         fullWidth
                         // error={meta.error}
                    >
                         <DatePicker
                              //   {...input}
                              selectsRange={true}
                              popperPlacement="top-end"
                              startDate={startDate}
                              endDate={endDate}
                              monthsShown={2}
                              className="red-border"
                              customInput={<CustomInput />}
                              onChange={(update) => {
                                   props.onChange(update);
                                   setDateRange(update);

                                   // if (
                                   //      !update.includes(
                                   //           null,
                                   //      )
                                   // ) {
                                   //      input.onChange(
                                   //           update,
                                   //      );
                                   // }
                              }}
                              isClearable={true}
                              maxDate={
                                   props.maxDate
                                        ? startDate
                                             ? new Date(
                                                    startDate.getTime() +
                                                         props.maxDateCount *
                                                              24 *
                                                              60 *
                                                              60 *
                                                              1000,
                                               )
                                             : null
                                        : null
                              }
                         />

                         {/* {meta.error && (
                                                  <FormHelperText className="component-error-text">
                                                       {meta.error}
                                                  </FormHelperText>
                                             )} */}
                    </FormControl>
               </div>
          </>
     );
}
